import {
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";

import { FiAlertCircle } from "react-icons/fi";
import moment from "moment";
import { FaCircle } from "react-icons/fa";
import { isMetaProperty } from "typescript";

import { toast } from "react-toastify";
import { useSetRecoilState, useRecoilState } from "recoil";

export default function ModalPaymentConfirmation({ isOpen, setIsOpen }: any) {
  const finalRef = React.useRef(null);

  const onClose = () => {
    // setIsOpen(false);
  };

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex
              w={"100%"}
              justifyContent={"center"}
              flexDir={"column"}
              mx={"auto"}
            >
              <Flex w={"100%"} h={"8%"} justifyContent={"center"}>
                <Image src={"./logo.png"} />
              </Flex>
              <Text fontWeight={"bold"}>Seu pagamento será processado.</Text>
              <Text fontWeight={"bold"}>Você já pode fechar esta página!</Text>
            </Flex>
          </ModalHeader>
          <ModalBody></ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
